import React from "react";
import { Button, Dialog, TextArea } from "@stonelog/stonelog-design-system";
import warning from "@assets/icons/Warning.svg";

import * as S from "../styles";

const CancelDialog = ({ open, deliveryId, motivo, onChangeMotivo, loading, onConfirm, onClose }) => (
  <Dialog.Root open={open} onCancel={onClose}>
    <Dialog.Header title="Cancelar delivery" />
    <Dialog.ContentHeader
      ilustration={<img src={warning} alt="Atenção" />}
      description={`Ao cancelar, todas as etapas ativas da delivery ${deliveryId || ""} serão canceladas e essa ação não pode ser desfeita. Informe o motivo para continuar.`}
    />
    <S.ReasonTextArea>
      <TextArea
        label="Motivo do cancelamento"
        value={motivo}
        onChange={(e) => onChangeMotivo(e.target.value)}
        charLimit={500}
      />
    </S.ReasonTextArea>
    <Dialog.Footer>
      <Button onClick={onClose}>Voltar</Button>
      <Button
        type="negative"
        onClick={onConfirm}
        disabled={!motivo.trim()}
        loading={loading}
      >
        Cancelar delivery
      </Button>
    </Dialog.Footer>
  </Dialog.Root>
);

export default CancelDialog;
